// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
    background-color: #F7E987;
    padding: 20px;
	color: #252B48;
	font-size: 15px;
    font-weight: 500;
    width: 100%;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;CAChB,cAAc;CACd,eAAe;IACZ,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB","sourcesContent":["footer {\n    background-color: #F7E987;\n    padding: 20px;\n\tcolor: #252B48;\n\tfont-size: 15px;\n    font-weight: 500;\n    width: 100%;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
